import Vue from 'vue'

import '../../../scss/app/85years.scss'

new Vue({
  el: '#js-winners-search',

  // language=HTML
  template: `
    <div class="winners-search">
      <div class="winners-search__search-input-row">
        <input type="search" placeholder="Search Winners" aria-label="Search Winners" v-model="query" />
      </div>

      <div class="winners-search__no-results" v-if="query.length && !results.length">
        <p>No results found</p>
      </div>
      <div class="winners-search__results" v-if="results.length">
        <ul class="winner-list">
          <li v-for="winner in results">
            <div class="winner">
              <div class="winner__trophy icon">
                <svg aria-hidden="true">
                  <use href="#trophy-icon"></use>
                </svg>
              </div>
              <div class="winner__info">
                <span class="winner__lname">{{ winner.l }}</span>
                <span class="winner__fname">{{ winner.f }}</span>
                <span class="winner_middle" v-if="winner.m">{{ winner.m }}{{ winner.m.length === 1 ? '.' : '' }}</span>
                <span class="winner__month">({{ winner.month }})</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  `,

  data() {
    return {
      query: '',
      results: [],
    }
  },

  computed: {
    allWinners() {
      const winners = []
      Object.entries(window.__WINNERS).forEach(([month, monthWinners]) => {
        monthWinners.forEach((winner) => {
          winners.push({ ...winner, month })
        })
      })
      return winners
    },

    winnersWithVariants() {
      return this.allWinners.map((winner) => {
        const variants = [
          `${winner.f + (winner.m ? ` ${winner.m}` : '')} ${winner.l}`,
          `${winner.f + (winner.m ? ` ${winner.m}.` : '')} ${winner.l}`,
          `${winner.f} ${winner.l}`,
          `${winner.l} ${winner.f}`,
        ].map((v) => v.toLowerCase())

        return { winner, variants }
      })
    },
  },

  watch: {
    query: {
      immediate: true,
      handler() {
        const lowercaseQuery = this.query.toLowerCase()
        if (!this.query.length) {
          this.showAccordion()
          this.results = []
          return
        }

        this.results = this.winnersWithVariants
          .filter(({ variants }) => variants.some((variant) => variant.includes(lowercaseQuery)))
          .map(({ winner }) => winner)

        if (this.results.length) {
          this.hideAccordion()
        } else {
          this.showAccordion()
        }
      },
    },
  },

  methods: {
    showAccordion() {
      document.querySelector('.winners-accordion').classList.remove('hide')
    },

    hideAccordion() {
      document.querySelector('.winners-accordion').classList.add('hide')
    },
  },
})
